<div class="container kite-container">

    <div class="row">
        <div class="col-12">
            <h3 class="float-right mr-3">PROSPECT AND INSTALLATION SEARCH</h3>
            <br>
        </div>
    </div>

    <div class="row animated fadeIn">
        <div class="col-12">
            <div class="card">
                <div class="card-body bg-white border" style="border-radius:15px!important">
                    <div class="row">
                        <div class="col">
                            <label class="label" for="surveysClientSearch">Client name</label>
                            <!-- Tier 6: wj-flex-grid-search replaced with the standard
                                 app-search-input. The wrapper's [quickFilterText] input
                                 drives AG Grid text filtering. -->
                            <app-search-input
                                [placeholder]="'Search...'"
                                (searchChange)="onSearch($event)">
                            </app-search-input>
                        </div>
                        <!-- <div class="col-3">
                            <button type="button" class="btn btn-themecolor btn-sm btn-block mt-4 rounded-pill" (click)="searchCustomer(inputTxt.value)">
                               Search
                            </button>
                        </div> -->
                        <!-- <div class="col-4">
                            <button type="button" class="btn btn-themecolor btn-sm btn-block mt-4 rounded-pill" (click)="open(newSurveyModal, 'lg', null)">
                               Create New Survey
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- --------------------------------------------------
    <h3>PRE-INSTALLATION SURVEY</h3>-->
    <!-- ** Alerta de No hay Registros y Cargando Datos -->
    <div class="row mt-4 animated fadeIn" *ngIf="surveys_arr_Tmp.length == 0">
        <div class="col">

            <div class="alert alert-info text-center" role="alert" *ngIf="message  !== 'No Data'">
                <strong>Loading</strong>
                <br>
                <i class="fa fa-spinner fa-spin fa-2x mt-2"></i>
                <br>
                <span class="mt-2">Please wait</span>
            </div>

            <div class="alert alert-warning text-center" role="alert" *ngIf="message == 'No Data'">
                <strong>{{message}}</strong>
                <br>
                <i class="fa fa-warning fa-2x"></i>
            </div>

        </div>
    </div>
    <!-- Wijmo. -->
    <div class="row">
        <div class="col-3">
          <app-custom-button
        [type]="'button'"
        style="background-color:#5bcc02; color: #fff;font-weight: 600; text-transform: uppercase;"
        [extraClasses]="
          'btn btn-default form-control d-inline-block btn-excel custom-btn btn-export-excel'
        "
        (buttonClick)="save()"
      >
        Export List
      </app-custom-button>
            <!-- <button (click)="save()" class="btn btn-default" style="background-color:#5bcc02; color: #fff;font-weight: 600; text-transform: uppercase;">
                             <i class="fa fa-file-excel text-success" style="color:#fff!important;"></i>
                              export list
                            </button> -->
        </div>
    </div>
    <div class="row animated fadeIn mt-1">
        <div class="col-12">
            <div class="card p-0">
                <div class="card-body bg-white p-0">

                    <div class="row">
                        <div class="col">

                            <div class="grid-panel">

                                <!-- Tier 6: wj-flex-grid → app-kite-grid. The 2
                                     action buttons (info, delete) are now part of a
                                     single createActionColumn on the left. The legacy
                                     <wj-flex-grid-column> elements are replaced by
                                     createPlainColumn calls in the component's columnDefs. -->
                                <app-kite-grid
                                    [columnDefs]="columnDefs"
                                    [rowData]="pagination_arr"
                                    [totalRecords]="pagination_arr.length"
                                    [pageSize]="pagination_arr.length || 1"
                                    (cellClicked)="onCellClicked($event)">
                                </app-kite-grid>


                            </div>
                            <br>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- -------------------------------------------------- -->

</div>

<!-- the popup editor -->

<wj-popup #editModal class="kite-modal-content">
    <div class="modal-header btn-themecolor dialog-title">
        <h4 class="modal-title text-white " id=" modalLabel ">UPDATE PROSPECT AND INSTALLATION DOCUMENT</h4>
        <button type="button " class="btn-close wj-hide" aria-label="Close " tabindex="-1">
        </button>
    </div>

    <div class="kite-modal-body p-4 ">

        <form [formGroup]="popupForm" (ngSubmit)="editSurvey(editModal)" autocomplete="off" ngNativeValidate>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                    <!-- **Firts Row -->
                    <div class="row m-0 p-0">
                        <div class="mb-3 ">
                            <label for="name" class="label">Client Name</label>
                            <input type="text " class="form-control kite-form-control border-0" id="name" formControlName="name_client_address" disabled>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md-4 mb-3">
                            <label for="tanksize" class="label">Capacity/ week needed</label>
                            <input type="number" min="0" class="form-control" id="tanksize" placeholder="" formControlName="capacity" [class.is-invalid]="capacityNoValido">
                            <small *ngIf="capacityNoValido" class="animated fadeIn text-danger">
                                            *Required
                                        </small>
                        </div>
                        <div class="col-md-4">
                            <label class="label">Room Available (INCHES)</label>
                            <div class="row m-0 p-0">
                                <div class="col mb-3 px-1">
                                    <!-- <label for="width" class="label">Room Available</label> -->
                                    <input type="number" min="0" class="form-control" id="width" placeholder="W" formControlName="room_w">
                                </div>
                                <div class="col mb-3 px-1">
                                    <!-- <label for="deep" class="form-label text-white">D</label> -->
                                    <input type="number" min="0" class="form-control" id="deep" placeholder="D" formControlName="room_d">
                                </div>

                                <div class="col mb-3 px-1">
                                    <!-- <label for="height" class="form-label text-white">H</label> -->
                                    <input type="number" min="0" class="form-control" id="height" placeholder="H" formControlName="room_h">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="label" for="best-date">Schedule job</label>
                            <div class="input-group input-group-sm">
                                <input type="datetime-local" class="form-control" id="best-date" name="best_date" formControlName="best_date">
                            </div>
                        </div>
                    </div>

                    <!-- **Second Row -->
                    <div class="row m-0 p-0">
                        <label class="label">TANK ACCESS</label>
                    </div>
                    <div class="row" style="border:solid 1px #08b9f2; border-radius:15px; margin: 0 10px 10px;">
                        <div class="col-sm-2" style="display: flex; align-items: center">
                            <div class="form-check form-check-inline m-0 p-0">
                                <input class="form-check-input" type="radio" name="tank_acces" id="tank_acces1" value="indoor" formControlName="tank_acces">
                                <label class="label" for="tank_acces1">Indoor</label>
                            </div>
                        </div>
                        <div class="col-sm-3 mb-3">
                            <label for="smallAccess" class="label">Smaller Access Width</label>
                            <input type="number" class="form-control" id="smallAccess" placeholder="Inches" formControlName="smaller_access">
                        </div>
                        <div class="col-sm-2" style="display:flex; align-items:center;">
                            <div class="form-check form-check-inline ml-1 p-0">
                                <input class="form-check-input" type="radio" name="tank_acces" id="tank_acces2" value="outdoor" formControlName="tank_acces">
                                <label class="label" for="tank_acces2">Outdoor</label>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <label for="tanksize" class="label">Door Hinge Side</label>
                            <input type="number" min="0" class="form-control" id="tanksize" placeholder="Inches" formControlName="door_hinge_side">
                        </div>
                    </div>
                    <!-- **Third Row -->

                    <div class="row m-0 p-0">
                        <div class="col-md mb-3">
                            <label for="tanksize" class="label">Tank & Stand Kind</label>
                            <input type="text" class="form-control" id="tanksize" placeholder="" formControlName="stand_kind" toUppercase>
                        </div>
                    </div>


                    <!-- **Fourth Row -->
                    <div class="row m-0 p-0">

                        <div class="col-md-3 mb-3">
                            <label for="smallAccess" class="label">Pull for Delivery</label>
                            <input type="number" min="0" class="form-control" id="smallAccess" placeholder="Feet" formControlName="pull_delivery">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label for="tanksize" class="label">Electrical outlet</label>
                            <input type="number" min="0" class="form-control" id="tanksize" placeholder="Feet" formControlName="electrical_outlet">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label for="tanksize" class="label">Permanet Hose</label>
                            <input type="number" min="0" class="form-control" id="tanksize" placeholder="Feet" formControlName="permanent_hose">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label for="tanksize" class="label">Dispensing Hose</label>
                            <input type="number" min="0" class="form-control" id="tanksize" placeholder="Feet" formControlName="dispensing_hose">
                        </div>

                    </div>

                    <!-- **Last Row -->
                    <div class="row m-0 p-0">

                        <div class="col-12">

                            <label for="floatingTextarea" class="label">Special Requirements</label>
                            <textarea class="form-control" placeholder="" id="floatingTextarea" style="height: 100px" formControlName="special_requirements" oninput="this.value = this.value.toUpperCase();"></textarea >


                                    </div>
                                </div>

                            </div>

                            <!-- **----------------- -->
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                                <div class="row">
                                    <div class="col">
                                        <label class="label" for="surveysUploadFiles">Upload files</label>
                                        <div class="input-group input-group-sm">
                                            <input id="surveysUploadFiles" #inputfile type="file" class="border border-1 rounded-start" placeholder="" (change)="setFile($event.target.files[0])">
                                            <span class="input-group-text btn-themecolor rounded-end pointer" style="padding-bottom: 3px !important;" (click)="showFiles()">
                                            Upload File
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col">
                                        <table class="table table-sm">
                                            <thead class="bg-light">
                                                <tr class="text-center">
                                                    <th colspan="2" scope="col">FILES ({{files_arr.length}})</th>
                                                </tr>
                                            </thead>
                                            <tbody class="tbody-scroll">
                                                <tr *ngFor="let file of files_arr">

                                                    <td class="td-scroll text-center">
                                                        <button type="button" class="pointer" data-toggle="tooltip" data-original-title="Borrar" (click)="removeFile(file)">
                                                            <i class="fa fa-trash text-inverse"></i>
                                                        </button>
                                                    </td>
                                                    <td class="td-scroll w300">{{file.name}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>

                      <div class="row">
                          <div class="modal-footer mx-auto">
                            <div class="col-sm"></div>
                            <div class="col-sm"></div>
                            <div class="col-sm">
                              <button type="submit" class="btn btn-themecolor btn-block kite-button">
                                UPDATE
                            </button>
                            </div>
                            <div class="col-sm">
                              <button type="button" class="btn btn-block kite-button-cancel wj-hide" aria-label="Close" tabindex="-1">
                                CANCEL
                              </button>
                            </div>
                            <div class="col-sm"></div>
                            <div class="col-sm"></div>
                          </div>
                      </div>

                    </form>
    </div>
</wj-popup>


<!-- MODAL DELETE -->
<ng-template #deleteModal let-modal>
    <div class="modal-header btn-themecolor dialog-title">
        <h4 class="modal-title text-white" id=" modalLabel">CONFIRM DELETE</h4>
        <button type="button " class="btn-close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
        </button>
    </div>
    <div class="modal-body">
        <div style="border-bottom: 1px solid #1CB9F2; padding:15px ; text-align: center">
            <h2 class="mr-2 kite-delete-label">Do you want to Delete the "Prospect and Installation" document associated to <strong>{{survey.name_survey}} ?</strong> </h2>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
          <div class="col text-center">
            <button type="button" class="btn kite-btn-close" data-dismiss="modal" (click)="modal.dismiss('close')">Close</button>
          </div>
           <div class="col text-center">
              <button type="button" class="btn kite-button-cancel"  (click)="deleteSurvey(modal, survey)">Yes, Delete it!</button>
            </div>
        </div>
    </div>

</ng-template>

<!-- MODAL INFO -->
<ng-template #infoModal let-modal>
    <div class="modal-header btn-themecolor dialog-title">
        <h4 class="modal-title text-white" id=" modalLabel">PROSPECT AND INSTALLATION DOCUMENT</h4>
        <button type="button " class="btn-close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
        </button>
    </div>
    <div class="modal-body">
      <div style="margin:3%!important">
        <div class="row" style="border:solid 1px #08b9f2; border-radius:15px; padding:3%">
          <div class="col-md-8">
            <label class="label">RESTAURANT</label>
            <p style="padding: 1.2%; background-color:#b7ecfe4f; color:#000; font-weight:600">{{survey.name_client_address | uppercase}}</p>
          </div>
          <div class="col-md-4">
            <label class="label" >BEST DAY FOR INSTALLATION</label>
            <p style="padding: 2%; background-color:#ececec; color:#000; font-weight:600">{{survey.best_date | uppercase}}</p>
          </div>
          <div class="col-sm-3">
            <label class="label" >SALES PERSON:</label>
            <p style="padding: 2%; border-radius:5px; background-color:#b7ecfe4f; color:#000; font-weight:600">{{survey.client.sales_person | uppercase}}</p>
          </div>
          <div class="col-sm-3">
            <label class="label">CONTACT NAME</label>
            <p style="padding: 2%; border-radius:5px; background-color:#b7ecfe4f; color:#000; font-weight:600" >{{survey.client.contact_name | uppercase}}</p>
          </div>
          <div class="col-sm-3">
            <label class="label">PHONE NUMBER</label>
            <p style="padding: 2%; border-radius:5px; background-color:#b7ecfe4f; color:#000; font-weight:600"> {{survey.client.phone}}</p>
          </div>
          <div class="col-sm-3">
            <label class="label" >EMAIL</label>
            <p style="padding: 2%; border-radius:5px; background-color:#b7ecfe4f; color:#000; font-weight:600">{{survey.client.email}}</p>
          </div>
        </div>
        </div>
        <div style="margin:3%!important">
            <div class="row">
              <div class="col-xl-3">
                <label class="label">CAPACITY / WEEK NEEDED:</label>
                <p style="border: 1px solid #dee2e6; padding: 2%; border-radius:5px;" >{{survey.capacity | uppercase}}</p>
              </div>
              <div class="col-lg">
                  <label class="label">ROOM AVAILABLE (INCHES): </label>
                  <div class="row">
                    <div class="col-sm-4">
                      <p style="border: 1px solid #dee2e6; padding: 9%; border-radius:5px;">{{survey.room_w | uppercase}} W</p>
                    </div>
                    <div class="col-sm-4">
                      <p style="border: 1px solid #dee2e6; padding: 9%; border-radius:5px">{{survey.room_d | uppercase}} D</p>
                    </div>
                    <div class="col-sm-4">
                      <p style="border: 1px solid #dee2e6; padding: 9%; border-radius:5px">{{survey.room_h | uppercase}} H</p>
                    </div>
                  </div>
              </div>
              <div class="col-sm">
                <label class="label">TANK ACCESS:</label>
                <div class="row">
                  <div class="col-sm">
                    <p style="border: 1px solid #dee2e6; padding: 2%; border-radius:5px;">{{survey.tank_acces | uppercase}}</p>
                    </div>
                </div>
              </div>
              <div class="col-sm">
                <label class="label">SMALLER ACCESS WIDTH:</label>
                <div class="row">
                  <div class="col-sm">
                    <p style="border: 1px solid #dee2e6; padding: 2%; border-radius:5px;">{{survey.smaller_access | uppercase}}</p>
                    </div>
                </div>
              </div>
              <div class="col-sm">
                <label class="label">DOOR HINGE SIDE:</label>
                <div class="row">
                  <div class="col-sm">
                    <p style="border: 1px solid #dee2e6;padding: 2%; border-radius:5px;">{{survey.door_hinge_side | uppercase}}</p>
                    </div>
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <label class="label" >TANK AND STAND KIND</label>
              <p style="border: 1px solid #dee2e6; padding: .75%; border-radius:5px">{{survey.stand_kind | uppercase}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <label class="label" >SPECIAL REQUERIMENTS</label>
              <p style="border: 1px solid #dee2e6; padding:2%; border-radius:5px">{{survey.special_requirements [0]}}</p>
            </div>
          </div>
          </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col text-center">
          <button type="button" class="btn kite-btn-close" data-dismiss="modal" (click)="modal.dismiss('close')">Close</button>
        </div>
      </div>
    </div>

</ng-template>
